import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const HeaderBlock = () => {
  const swap_request_title = i18n.t('shift_management.swap_shifts.approval_requests.inbox.title')
  const swap_request_description = i18n.t(
    'shift_management.swap_shifts.approval_requests.inbox.description'
  )

  return (
    <>
      <Box flexDirection="column" gap="s12" alignSelf="flexStart">
        <Text size="300" weight="semibold" color="grey1000">
          {swap_request_title}
        </Text>
        <Text size="300" weight="normal" color="grey1000">
          {swap_request_description}
        </Text>
      </Box>
    </>
  )
}

export default HeaderBlock
